module.exports = __webpack_public_path__ + "static/media/lyft.5cf0ec68.svg";